import styles from './banner.module.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Parallax, Pagination, Navigation, Autoplay } from 'swiper/modules';


export default function Banner() {

  const slidesContents = [
    { id: 1, title: 'پلاستیک و شیشه آلات آزمایشگاهی', description: 'انواع ظروف کشت سلولی، میکروتیوب‌ها در اندازه‌های مختلف، ظروف نگهداری نمونه و شیشه‌آلات آزمایشگاهی از برندهای معتبر جهانی مطابق با نیازهای متنوع پژوهشگاه‌ها، آزمایشگاه‌ها، مراکز تحقیقاتی و صنایع مرتبط', image: "/assets/images/banner/plastics.png" },
    { id: 2, title: 'مواد شیمیایی', description: 'سال‌ها تجربه و تخصص در زمینه واردات و تهیه مواد شیمیایی آلی و معدنی از برندهای معتبر جهانی و توزیع گسترده در صنایع مختلف از جمله داروسازی، کشاورزی، پتروشیمی، رنگ‌سازی و ... در سراسر کشور', image: "/assets/images/banner/chemicals.png" },
    // { id: 3, title: 'تجهیزات آزمایشگاهی', description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که', image: "/assets/images/banner/tankSeries.png" },
  ];

  return (
    <section className={styles.banner_container}>
      <div className={styles.leftIlluminated}></div>
      <div className={styles.rightIlluminated}></div>
      <img className={styles.bigCyanVirus} src="/assets/images/banner/virus-min.png" alt="virus" />
      <div className={styles.smallCyanVirus_container}>
        <img className={styles.smallCyanVirus} src="/assets/images/banner/virus-min.png" alt="virus" />
      </div>
      <img className={styles.topCells} src="/assets/images/banner/cells.png" alt="cells" />
      <img className={styles.bottomCells} src="/assets/images/banner/cells.png" alt="cells" />
      <img className={styles.outerEllipseLight} src="/assets/images/banner/Ellipse-light.svg" alt="ellipse" />
      <img className={styles.innerEllipseLight} src="/assets/images/banner/Ellipse-light.svg" alt="ellipse" />
      {/* <img className={styles.monoCell} src="/assets/images/banner/cell.png" alt="cell" /> */}
      <Swiper
        style={{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
        }}
        speed={3000}
        parallax={true}
        autoplay={{ delay: 3000, }}
        loop={true}
        modules={[Parallax, Pagination, Navigation, Autoplay]}
        className={styles.swiper}
      >
        {/* <div
          slot="container-start"
          className="parallax-bg"
          style={{
            'background-image':
              'url(https://swiperjs.com/demos/images/nature-1.jpg)',
          }}
          data-swiper-parallax="-23%"
        ></div> */}

        <SwiperSlide className={styles.swiperSlide}>
          <div className={`${styles.slideContent} d-flex flex-column gap-3 mt-5 mx-auto`}>
            <h2 className={`${styles.title} h3 lh-lg mt-5 text-center`} data-swiper-parallax="-300">
              تجهیزات پیشرفته برای تحقیقات علمی شما
            </h2>
            <p className={`${styles.description} h6 lh-lg mt-4 text-center`} data-swiper-parallax="-4000">
              {/* ارائه بهترین تجهیزات و مواد شیمیایی برای پژوهش‌های سلولی، مولکولی و شیمیایی */}
              ارائه بهترین تجهیزات و مواد شیمیایی در زمینه علوم آزمایشگاهی و دارویی و شیمیایی
            </p>
          </div>
        </SwiperSlide>

        {slidesContents.map(slide =>
          <SwiperSlide className={styles.swiperSlide} key={slide.id}>
            <div className={`${styles.slideContent} d-flex flex-column gap-3 mt-5 mx-auto`}>
              <h2 className={styles.title} data-swiper-parallax="-300">{slide.title}</h2>
              <p className={styles.description} data-swiper-parallax="-4000">{slide.description}</p>
              <img data-swiper-parallax="-5000"
                src={slide.image} alt={slide.title} style={{ width: '250px', height: '250px', objectFit: 'contain', }}
              />
            </div>
          </SwiperSlide>
        )}

      </Swiper>
    </section>
  );
}
